import React from "react";
import { StyledMainPageContainer } from "index.styles";
// Components
import SchemaComponent from "components/CBSchema";
import SEO from "components/CBSEO";
import TextBlock from "components/TextBlock";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import { ImageContainer } from "styles/components/imageContainer";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";
import BeforeYourSession from "./components/beforeYourSession";
import AfterYourSession from "./components/afterYourSession";
// Hooks
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";
// Data
import sessionPreparationSchemaData from "./schema.organization.json";
import sessionPreparationArticleSchemaData from "./schema.article.json";
import seoData from "./seo.data.json";
import sessionPreparationContent from "./data/pageContentData/sessionPreparationContent.data.json";
import CBDivider from "components/CBDivider";

const componentMap = {
  "TwoColumnSection": TwoColumnSection,
  "TextBlock": TextBlock,
  "ImageContainer": ImageContainer,
  "BeforeYourSession": BeforeYourSession,
  "AfterYourSession": AfterYourSession,
  "GetStartedToday": GetStartedToday,
  "Divider": CBDivider,
};

const SPREAD_PROPS_COMPONENTS = ["TextBlock", "TwoColumnSection", "BeforeYourSession", "AfterYourSession", "GetStartedToday"];

const SessionPreparation = () => {
  const schemaData = constructSchemaData(
    sessionPreparationSchemaData.url,
    sessionPreparationSchemaData.breadcrumbs,
    sessionPreparationArticleSchemaData,
  );
  const renderedComponents = useDynamicPageRenderer(sessionPreparationContent, componentMap, SPREAD_PROPS_COMPONENTS);

  return (
    <StyledMainPageContainer id="session-preparation-page-container">
      <SchemaComponent schemas={schemaData} />
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      {renderedComponents}
    </StyledMainPageContainer>
  );
};

export default SessionPreparation;
